import { useLocation, useNavigate } from "react-router-dom";
import { TableComponent } from "V2.0/HomePages/HomeModule/CustomAPIs/components/TableComponent";
import { RiWhatsappLine, RiMessengerLine } from "react-icons/ri";
import { FaInstagram } from "react-icons/fa";
import { MdOutlineAttachEmail } from "react-icons/md";
import {
  EnvelopeIcon,
  ChatBubbleBottomCenterTextIcon,
  GlobeAltIcon,
  PhoneArrowUpRightIcon,
  ChatBubbleLeftIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  LockClosedIcon,
} from "@heroicons/react/24/outline";
import {
  Table,
  TableBody,
  TableHeader,
  TableHead,
  TableCell,
  TableRow,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import {
  DocumentDuplicateIcon,
  PencilIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import { Tooltip } from "antd";
import { useMemo } from "react";

export const Icons = {
  whatsapp: <RiWhatsappLine className="size-5" />,
  chat: <ChatBubbleOvalLeftEllipsisIcon className="size-5" />,
  sms: <ChatBubbleBottomCenterTextIcon className="size-5" />,
  voice: <PhoneArrowUpRightIcon className="size-5" />,
  messenger: <RiMessengerLine className="size-5" />,
  instagram: <FaInstagram className="size-5" />,
  email: <MdOutlineAttachEmail className="size-5" />,
};

function SourceIcon({ children }) {
  return (
    <div className="h-10 w-10 flex justify-center items-center">{children}</div>
  );
}

export function AssistantsTable(props) {
  const {
    assistants,
    onDelete,
    onDuplicate,
    allowAssistantCreation,
    onEdit,
    isViewOnly,
  } = props;
  const navigate = useNavigate();
  const location = useLocation();

  function handleRowClick(assistantId) {
    navigate({
      pathname: `/assistants/${assistantId}`,
      search: location.search,
    });
  }

  const alphabeticallySortedAssistants = useMemo(() => {
    if (assistants.isLoading) {
      return [];
    }

    if (assistants.data.length === 0) {
      return [];
    }

    const _assistants = [...assistants.data];
    _assistants.sort((a, b) => a.name.localeCompare(b.name));
    return _assistants;
  }, [assistants]);

  if (assistants.isLoading) {
    return null;
  }

  return (
    <Table>
      <TableHead className="">
        <TableHeader className="">Assistant</TableHeader>
        <TableHeader>Action</TableHeader>
      </TableHead>
      <TableBody>
        {alphabeticallySortedAssistants.map((assistant, index) => {
          const { _id, assistantType, name, description, locked } = assistant;
          return (
            <TableRow
              key={_id}
              onClick={() => handleRowClick(_id)}
              className="hover:bg-gray-100 hover:cursor-pointer"
            >
              <TableCell>
                <div className="flex items-start gap-x-2 min-h-16">
                  <div>
                    <SourceIcon>{Icons[assistantType]}</SourceIcon>
                  </div>
                  <div className="flex flex-col gap-y-2">
                    <p className="font-semibold text-sm/8">{name}</p>
                    <Tooltip title={description}>
                      <p className="text-sm text-gray-500 truncate max-w-[400px]">
                        {description}
                      </p>
                    </Tooltip>
                  </div>
                </div>
              </TableCell>
              <TableCell>
                {!(locked || isViewOnly) ? (
                  <div className="flex gap-x-2">
                    {/* <Button
                      outline
                      onClick={(e) => {
                        e.stopPropagation();
                        onEdit(assistant);
                      }}
                    >
                      <PencilIcon />
                    </Button> */}
                    <Tooltip title="Duplicate">
                      <Button
                        outline
                        onClick={(e) => {
                          e.stopPropagation();
                          onDuplicate(assistant);
                        }}
                      >
                        <DocumentDuplicateIcon />
                      </Button>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <Button
                        outline
                        onClick={(e) => {
                          e.stopPropagation();
                          onDelete(assistant);
                        }}
                      >
                        <TrashIcon />
                      </Button>
                    </Tooltip>
                  </div>
                ) : (
                  <Tooltip title="Assistant is locked">
                    <LockClosedIcon className="size-6 text-red-500" />
                  </Tooltip>
                )}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
